<template>
  <span
    class="com-channel-link-common-link-text"
    @click.stop="onTextNodeClick"
  ># {{ tCname }}</span>&nbsp;
</template>
<script lang="ts" setup>
import { logger } from '_c/util/logger';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from '@/store';
import { onBeforeMount, PropType, ref } from 'vue';
import { useToast } from '@/component/kk-toast';
const { error } = useToast();

const props = defineProps({
  displayName: {
    type: String,
    default: '',
  },
  ext: {
    type: Object as PropType<Record<string, unknown>>,
    default: () => null,
  },
});
let gid: number|null = null;
let cid: number|null = null;
let tGid = 0;
let tCid = 0;
const tCname = ref('');
let navigatorLock = false;
const router = useRouter();
const store = useStore();
const route = useRoute();
function onTextNodeClick(): void {
  logger.info(`[component-message-text-component-common-link-component-channel-link] [onTextNodeClick] inject gid: ${gid}, cid: ${cid}, tGid: ${tGid}, tCid: ${tCid}`);
  if (tGid !== gid) {
    error('不可以跨群跳转哦~');
  } else if (`${tCid}` === `${cid}`) {
    error('已经在当前频道~');
  } else {
    if (navigatorLock) return;
    navigatorLock = true;
    store.dispatch('group/getGroupInfo', { groupId: tGid })
      .then(() => {
        const groupInfo = store.state.group.groupList.find(item => `${item.info.gid}` === `${tGid}`);
        if (groupInfo) {
          const cidList = groupInfo.chanList.map(item => `${item.cid}`);
          const i = cidList.indexOf(`${tCid}`);
          if (i > -1) {
            router.push({
              name: 'MainChatPage',
              params: {
                gid: tGid.toString(),
                cid: tCid.toString(),
              },
              query: {
                ...route.query as Record<string, string>,
              },
              hash: route.hash,
            });
          } else {
            error('频道不存在~');
          }
        } else {
          error('获取频道信息有误，请稍后重试~');
        }
      })
      .catch((err: Error) => {
        logger.info('[component-message-text-component-common-link-component-channel-link] [onTextNodeClick] getGroupInfo error: ', err);
        error('获取频道详情失败，请稍候重试~');// TODO 替换toast
      })
      .finally(() => {
        navigatorLock = false;
      });
  }
}
onBeforeMount(() => {
  gid = Number(route.params?.gid) ?? null;
  cid = Number(route.params?.cid) ?? null;
  const { gid: extGid, cid: extCid, cname: extCname } = props.ext;
  tGid = Number(extGid) || 0;
  tCid = Number(extCid) || 0;
  tCname.value = `${extCname}` || '';
});
</script>

<style lang="scss">
.com-channel-link-common-link-text {
  color: #267be7;
  background-color: #f2f4f7;
  cursor: pointer;
}
</style>
